export default "__VITE_PUBLIC_ASSET__88289bd4__"